import { render, staticRenderFns } from "./CourseEventRegistrationList.vue?vue&type=template&id=3b79a730&scoped=true"
import script from "./CourseEventRegistrationList.vue?vue&type=script&lang=js"
export * from "./CourseEventRegistrationList.vue?vue&type=script&lang=js"
import style0 from "./CourseEventRegistrationList.vue?vue&type=style&index=0&id=3b79a730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b79a730",
  null
  
)

export default component.exports